<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                d="M0.34375 3.46875C0.34375 1.74286 1.74286 0.34375 3.46875 0.34375H17.5312C19.2571 0.34375 20.6562 1.74286 20.6562 3.46875V13.625C20.6562 15.3509 19.2571 16.75 17.5312 16.75H14.4062V17.0181C14.4062 17.6397 14.6532 18.2358 15.0927 18.6754L15.7399 19.3226C15.9634 19.546 16.0302 19.882 15.9093 20.174C15.7884 20.4659 15.5035 20.6562 15.1875 20.6562H5.8125C5.49651 20.6562 5.21164 20.4659 5.09072 20.174C4.9698 19.882 5.03664 19.546 5.26007 19.3226L5.90728 18.6754C6.34682 18.2358 6.59375 17.6397 6.59375 17.0181V16.75H3.46875C1.74286 16.75 0.34375 15.3509 0.34375 13.625V3.46875ZM1.90625 3.46875V11.2812C1.90625 12.1442 2.6058 12.8438 3.46875 12.8438H17.5312C18.3942 12.8438 19.0938 12.1442 19.0938 11.2812V3.46875C19.0938 2.60581 18.3942 1.90625 17.5312 1.90625H3.46875C2.60581 1.90625 1.90625 2.60581 1.90625 3.46875Z"
                :fill="color" 
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgDisplay',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>